/**
 * TEMP — long-press gesture debug logging for FAB validation.
 */
import { ASHLEY_DEBUG_ENABLED } from "../ashley/debug/ashleyDebugConfig";
import { voiceDiag } from "../ashley/debug/ashleyVoiceDiagnostics";

export const LONG_PRESS_DEBUG = ASHLEY_DEBUG_ENABLED;

const PANEL_EVENTS = new Set([
  "fire-long-press",
  "fire-blocked",
  "timer-cancelled",
  "pointer-up",
  "contextmenu-ignored",
  "contextmenu-long-press",
]);

/** @param {string} event @param {object} [data] */
export function longPressDebug(event, data) {
  if (!LONG_PRESS_DEBUG) {
    return;
  }
  console.log("[LongPress]", event, data ?? "");

  if (PANEL_EVENTS.has(event)) {
    voiceDiag(`LongPress: ${event}`, {
      hypothesisId: "H-LP",
      location: "createCarouselLongPressHandlers",
      data: data ?? undefined,
    });
  }
}
